import { getModuleSidebarNavCohortListApi } from 'api/views';

import {
  MyTeam,
  MyGoals,
  MyTeamGoals,
  MyOrgGoals,
  MyCompanyGoals,
  MyTeamReviews,
  MyOrgReviews,
  MyCompanyReviews,
  MyTeamOneOnOnes,
  MyOrgOneOnOnes,
  MyCompanyOneOnOnes,
  MyTeamDevelop,
  MyOrgDevelop,
  MyCompanyDevelop,
  MyInitiatives,
  MyTeamEngagements,
  MyOrgEngagements,
  MyCompanyEngagements,
  MyDefaultOneOnOneLatest,
  MyTeamDefaultOneOnOneLatest,
  MyCompanyDefaultOneOnOneLatest,
  MyOrgDefaultOneOnOneLatest,
  MyInitiativeLatest,
  MyTeamInitiativeLatest,
  MyOrgFeedback,
  MyTeamFeedback,
  MyCompanyFeedback,
} from 'assets/assetsV1/iconComponents';

export const SIDEBAR_ICONS_FOR_TYPES = {
  defaultList: {
    MY_TEAM: MyTeam,
  },
  // rest keys are from MODULE_KEYS1
  // dynamic keys are not working in storybook for some reason, that's why doing like this
  goal: {
    MY_OKRs: MyGoals,
    MY_TEAM: MyTeamGoals,
    MY_ORGANIZATION: MyOrgGoals,
    ALL_EMPLOYEE: MyCompanyGoals,
  },
  initiative: {
    MY_OKRs: MyInitiatives,
    MY_TEAM: MyTeamInitiativeLatest,
    MY_INITIATIVES: MyInitiativeLatest,
  },
  status: {
    ALL_EMPLOYEE: MyCompanyReviews,
    MY_ORGANIZATION: MyOrgReviews,
  },
  oneOnOne: {
    MY_ONE_ON_ONE: MyDefaultOneOnOneLatest,
    ALL_EMPLOYEE: MyCompanyDefaultOneOnOneLatest,
    MY_TEAM: MyTeamDefaultOneOnOneLatest,
    MY_ORGANIZATION: MyOrgDefaultOneOnOneLatest,
  },
  levelUp: {
    ALL_EMPLOYEE: MyCompanyDevelop,
    MY_ORGANIZATION: MyOrgDevelop,
  },
  engagement: {
    ALL_EMPLOYEE: MyCompanyEngagements,
    MY_TEAM: MyTeamEngagements,
    MY_ORGANIZATION: MyOrgEngagements,
  },
  continuousFeedback: {
    ALL_EMPLOYEE: MyCompanyFeedback,
    MY_ORGANIZATION: MyOrgFeedback,
    MY_TEAM: MyTeamFeedback,
  },
};

export const SIDEBAR_ICONS_FOR_NAMES = {
  // keys are from MODULE_KEYS1
  // dynamic keys are not working in storybook for some reason, that's why doing like this

  status: {
    'My Team': MyTeamReviews,
    'All Employees': MyCompanyReviews,
    'My Organization': MyOrgReviews,
  },
  oneOnOne: {
    'My Team': MyTeamOneOnOnes,
    'All Employees': MyCompanyOneOnOnes,
    'My Organization': MyOrgOneOnOnes,
  },
  initiative: {
    'My Team': MyTeamInitiativeLatest,
  },
  levelUp: {
    'My Team': MyTeamDevelop,
    'All Employees': MyCompanyDevelop,
    'My Organization': MyOrgDevelop,
  },
  continuousFeedback: {
    'My Team': MyTeamDevelop,
    'All Employees': MyCompanyDevelop,
    'My Organization': MyOrgDevelop,
  },
  engagement: {
    'My Team': MyTeamEngagements,
    'All Employees': MyCompanyEngagements,
    'My Organization': MyOrgEngagements,
  },
};

export const getModuleSidebarNavCohorts = ({ moduleType }) => {
  const apiFunction = getModuleSidebarNavCohortListApi;
  return apiFunction({ moduleType }).then((res) => {
    const { cohortList, defaultList } = res?.entity ?? {};
    const defaultListWithIcons = defaultList.map((defaultItem) => ({
      ...defaultItem,
      icon:
        SIDEBAR_ICONS_FOR_TYPES?.[moduleType]?.[defaultItem?.type] ??
        SIDEBAR_ICONS_FOR_NAMES?.[moduleType]?.[defaultItem?.name] ??
        SIDEBAR_ICONS_FOR_TYPES.defaultList.MY_TEAM,
    }));

    const cohortListWithIcons = cohortList.map((defaultItem) => ({
      ...defaultItem,
      icon: SIDEBAR_ICONS_FOR_TYPES.defaultList.MY_TEAM,
    }));
    return { cohortList: cohortListWithIcons, defaultList: defaultListWithIcons };
  });
};
